
































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import DynamicDocumentEventConfigurationTemplate from '@/views/dynamicdocuments/fields/dynamic-document-event-configuration-template.vue';

@Component({
  name: 'dynamic-document-signature-eventctrl-template',
  components: {
    DynamicDocumentEventConfigurationTemplate,
    AmetrasSelectFieldTemplate
  }
})
export default class DynamicDocumentSignatureEventctrlTemplate extends Vue {

  @Prop({required: true}) fieldConfig!: DisguiseDto.DynamicDocumentFieldTypeSignatureDtoV2;

  afterCaptureSelection: DisguiseDto.DynamicDocumentEventDto['@type'] | '' = '';
  afterCaptureEventPossibleSelection: DisguiseDto.SelectDto[] = [{
    text: '',
    value: ''
  }, {
    text: 'Sperre Dokument',
    value: 'LOCK'
  }, {
    text: 'Prüfe Feldregeln',
    value: 'FIELD_RULES_CHECK'
  }];

  beforeCaptureSelection: DisguiseDto.DynamicDocumentEventDto['@type'] | '' = '';
  beforeCaptureEventPossibleSelection: DisguiseDto.SelectDto[] = [{
    text: '',
    value: ''
  }, {
    text: 'Prüfe Dokument',
    value: 'CHECK'
  }];

  innerValue!: DisguiseDto.DynamicDocumentFieldTypeSignatureDtoV2;

  created() {
    if (this.fieldConfig) {
      if (this.fieldConfig.afterCaptureEvent !== undefined) {
        this.afterCaptureSelection = this.fieldConfig.afterCaptureEvent['@type'];
      }
      if (this.fieldConfig.beforeCaptureEvent !== undefined) {
        this.beforeCaptureSelection = this.fieldConfig.beforeCaptureEvent['@type'];
      }
    }
    this.innerValue = this.fieldConfig;
  }

  @Watch('value') valueChanged(newValue: DisguiseDto.DynamicDocumentFieldTypeSignatureDtoV2) {
    this.innerValue = newValue;
  }

  @Watch('innerValue') innerValueChanged(newValue: DisguiseDto.DynamicDocumentFieldTypeSignatureDtoV2) {
    this.$emit('input', newValue);
  }

  afterCaptureSelectionChanged(
      newValue: DisguiseDto.DynamicDocumentEventDto['@type'] | ''
  ) {
    if (this.fieldConfig) {
      if (newValue) {
        this.fieldConfig.afterCaptureEvent = {
          '@type': newValue
        };
      } else {
        delete this.fieldConfig.afterCaptureEvent;
      }
      this.$forceUpdate();
    }
  }

  beforeCaptureSelectionChanged(
      newValue: DisguiseDto.DynamicDocumentEventDto['@type'] | ''
  ) {
    if (this.fieldConfig) {
      if (newValue) {
        this.fieldConfig.beforeCaptureEvent = {
          '@type': newValue
        };
      } else {
        delete this.fieldConfig.beforeCaptureEvent;
      }
      this.$forceUpdate();
    }
  }

}
